import { Avatar, Box, Button, Grid, Stack, Typography } from "@mui/material";
import MuiCard from "@mui/material/Card";
import { PropTypes } from "prop-types";
import { useNavigate } from "react-router-dom";
import developers from "../../_mock/developer";

const Card = ({ developer }) => {
  const navigate = useNavigate();
  return (
    <MuiCard
      sx={{
        height: 320
      }}
    >
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="50%"
      >
        <Avatar
          src={developer.img}
          alt={developer.name}
          sx={{ width: 108, height: 108 }}
        />
      </Stack>
      <Box p={2} textAlign="center">
        <Typography variant="body1">{developer.name}</Typography>
        <Typography variant="body1" color="primary">
          {developer.role}
        </Typography>
        <br />
        <Stack direction="row" justifyContent="center" spacing={2}>
          <Button
            variant="outlined"
            onClick={() => navigate(`details/${developer.id}`)}
          >
            Details
          </Button>
          <Button
            variant="outlined"
            onClick={() => navigate(`hire/${developer.id}`)}
          >
            Hire
          </Button>
        </Stack>
      </Box>
    </MuiCard>
  );
};

Card.propTypes = {
  developer: PropTypes.object
};

export default function DeveloperList() {
  return (
    <Box mt={4}>
      <Typography variant="h4" sx={{ textAlign: "center", mb: 2 }}>
        Hire the best Specialists from KeywordsFly
      </Typography>
      <Grid container spacing={2}>
        {developers.map((e, i) => (
          <Grid key={i} item xs={3}>
            <Card developer={e} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
